import reducerNamespace from '../constants/reducerNamespace';
import reducer from '../modules';
import Notification from '../components';

// @TODO implement in workspace, needs tweaking in sui first.
const createComponentInterface = (store) => ({
    reducerNamespace,
    reducer,
    Component: Notification,
});

export default createComponentInterface;
